
  
  export const SET_ESTIMACIONVERSION = "SET_ESTIMACIONVERSION";
  export const CREATE_ESTIMACIONVERSION = "CREATE_ESTIMACIONVERSION";
  export const ESTIMACIONVERSIONES_RECEIVED = "EstimacionVersiones_RECEIVED";
  export const SET_PROPERTY_ESTIMACIONVERSION = "SET_PROPERTY_ESTIMACIONVERSION";
  